const money = (value) => Math.round((Number(value) || 0) * 100);

// A recharge can also carry cardId: that link alone is not proof of a debit.
export function cashlessAmountForCard(order, cardId) {
  const status = order.status == null ? null : String(order.status).toLowerCase();
  if (status != null && !['paid', 'complete', 'completed', 'confirmed'].includes(status)) return 0;
  if (order.tablePaymentAllocationVersion !== 2 && order.paymentType === "cashless" && order.cardId === cardId && status !== "confirmed") {
    return money(order.totalAmount);
  }
  const splits = Array.isArray(order.splitPayments) ? order.splitPayments : [];
  const cashless = splits.filter((payment) => payment.paymentType === "cashless");
  const matching = cashless.filter((payment) =>
    payment.cardId === cardId || (!payment.cardId && order.cardId === cardId),
  );
  if (!matching.length) return 0;
  const total = splits.reduce((sum, payment) => sum + money(payment.amount), 0);
  const matched = matching.reduce((sum, payment) => sum + money(payment.amount), 0);
  // Table notes copy one batch-wide split list to several orders. Allocate each
  // order's share instead of counting the same debit once for every table order.
  if (order.tablePaymentAllocationVersion === 2) return matched;
  const orderTotal = money(order.totalAmount);
  return total > orderTotal && total > 0 ? Math.round(matched * orderTotal / total) : matched;
}

export function aggregateCashlessConsumption(orders, cardId) {
  const products = new Map();
  for (const order of orders) {
    const amount = cashlessAmountForCard(order, cardId);
    if (!amount) continue;
    const lines = Array.isArray(order.products) ? order.products : [];
    const subtotal = lines.reduce((sum, product) => sum + money(product.totalDue), 0);
    let cumulative = 0;
    let allocated = 0;
    for (const product of lines) {
      cumulative += money(product.totalDue);
      const next = subtotal ? Math.round(cumulative * amount / subtotal) : 0;
      const lineAmount = next - allocated;
      allocated = next;
      const key = JSON.stringify([product.id || "", product.title || ""]);
      const current = products.get(key) || { id: key, title: product.title, quantity: 0, cents: 0 };
      current.quantity += Number(product.quantity) || 0;
      current.cents += lineAmount;
      products.set(key, current);
    }
  }
  return [...products.values()].map(({ cents, ...product }) => ({ ...product, totalDue: cents / 100 }));
}
